import { render, staticRenderFns } from "./Lodging.vue?vue&type=template&id=3f1df021&scoped=true&"
import script from "./Lodging.vue?vue&type=script&lang=js&"
export * from "./Lodging.vue?vue&type=script&lang=js&"
import style0 from "./Lodging.vue?vue&type=style&index=0&id=3f1df021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1df021",
  null
  
)

export default component.exports